import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/components/page-header';
import { getUrlParam, setWebTitle, todayStart, next10DaysStart } from '@/lib/format-utils';
import DatePickerCustom from '@/components/custom-date-picker';
import { useMoneyTransactions } from '@/hooks/api-hooks';
import { SkeletonList } from '@/components/snippets';
import MoneyTransactionsTable from '@/components/money-transactions-table';

export default function MoneyTransactionsPage(): JSX.Element {
    const { t } = useTranslation();
    setWebTitle(t('money_transactions'));

    const [dateRange, setDateRange] = useState<[string, string]>([
        getUrlParam('start', todayStart()),
        getUrlParam('end', next10DaysStart())
    ]);

    const {
        data,
        isLoading
    } = useMoneyTransactions({
        start: dateRange[0],
        end: dateRange[1],
    });

    return (
        <div>
            <PageHeader
                title={t('money_transactions')}
            />
            <div className="panel-content">
                <div className="flex items-end gap-2 mb-6">
                    <DatePickerCustom
                        size="sm"
                        valueFormat="DD MMM YYYY"
                        label={t('date')}
                        clearable={false}
                        value={dateRange}
                        onChange={setDateRange}
                    />
                </div>

                <MoneyTransactionsTable
                    moneyTransactions={data?.data || []}
                />

                {isLoading && <SkeletonList />}
            </div>
        </div>
    );
}
